import { render, staticRenderFns } from "./BaseResetButton.vue?vue&type=template&id=638b59fe&"
import script from "./BaseResetButton.vue?vue&type=script&lang=js&"
export * from "./BaseResetButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports